import { type FC } from 'react'

import { ErxBonusLandingPageHeroV1 } from './ErxBonusLandingPageHero'
import { ErxBonusLandingPageHeroActionsV1 } from './ErxBonusLandingPageHeroActions'

export const ErxBonusLandingPageHeroHeaderV1: FC = () => {
  return (
    <div className="bg-light-brand-medium">
      <div className="container flex h-[380px] flex-col-reverse py-4 tablet:flex-row tablet:justify-between">
        <ErxBonusLandingPageHeroActionsV1 />
        <ErxBonusLandingPageHeroV1 />
      </div>
    </div>
  )
}
